import { FormattedMessage } from 'react-intl'

export default function LiveaboardRequirementsText({ requirements }) {
  return (
    <div className='mtm'>
      <p className='bold'>
        <FormattedMessage
          defaultMessage='As a reminder, the requirements for taking part in this trip as a diver are the following'
          id='reqirements_reminder'
        />
      </p>

      <table className='requirement-table'>
        <tr>
          <td className='requirement-table__title'>
            <FormattedMessage
              defaultMessage='# of logged dives'
              id='number_of_logged_dives'
            />
          </td>
          <td>{requirements?.minimalNumberOfDives || '-'}</td>
        </tr>
        <tr>
          <td className='requirement-table__title'>
            <FormattedMessage
              defaultMessage='Certifications'
              id='certivications'
            />
          </td>
          <td>{requirements?.requiredCertification || '-'}</td>
        </tr>
        <tr>
          <td className='requirement-table__title'>
            <FormattedMessage defaultMessage='Other' id='other' />
          </td>
          <td>{requirements?.experienceRequired || '-'}</td>
        </tr>
      </table>
      <p>
        <FormattedMessage
          id='if_do_not_meet'
          defaultMessage='If you do not meet these requirements you should contact one of our scuba travel experts as soon as possible.'
        />
      </p>
      <p>
        <FormattedMessage
          id='if_all_good'
          defaultMessage='If all is good, we look forward to confirming your booking shortly.'
        />
      </p>
    </div>
  )
}
